<div class="row col-12" *ngIf="attachmentList?.length > 15 && action === addAttachment">
    <label class="has-error">
        {{ 'attachmentExceedsAllowedLength' | translate }}
    </label>
</div>
<div class="row col-12" *ngIf="isSizeExceedsLimit() && action === addAttachment">
    <label class="has-error">
        {{ 'attachmentSizeExceedsLimit' | translate:{ currentSize: getTotalSizeInMB().toFixed(2), maxSize: '15' } }}
    </label>
</div>
<div
    class="attachment-list-container"
    [ngClass]="{
        'attachment-error': attachmentList?.length > 15 && action === addAttachment
    }"
>
    <div class="attachment-list-wrapper custom-visible-scroll">
        <app-attachment-item
            *ngFor="let attachment of attachmentList"
            [attachment]="attachment"
            [requestId]="requestId"
            [reportId]="reportId"
            [action]="action"
            [commentId]="commentId"
            [moduleName]="moduleName"
            [viewType]="viewType"
        >
        </app-attachment-item>
    </div>
</div>
